import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const BrandVoiceItemEmptyBanner = ({
  className,
  TitleIcon,
  titleIcon,
  title,
  description,
  children,
}) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.titleWrapper}>
        {(TitleIcon || titleIcon) && (
          <div className={styles.iconWrapper}>
            {TitleIcon && <TitleIcon />}
            {titleIcon}
          </div>
        )}

        <CustomTypography
          className={styles.title}
          variant={TYPOGRAPHY_VARIANT.h2}
        >
          {title}
        </CustomTypography>
      </div>

      {description && (
        <CustomTypography
          className={styles.description}
          variant={TYPOGRAPHY_VARIANT.paragraph16}
        >
          {description}
        </CustomTypography>
      )}

      {children}
    </div>
  );
};

BrandVoiceItemEmptyBanner.propTypes = {
  className: PropTypes.string,
  TitleIcon: PropTypes.elementType,
  titleIcon: PropTypes.node,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node,
};
BrandVoiceItemEmptyBanner.defaultProps = {
  className: null,
  TitleIcon: null,
  titleIcon: null,
  description: null,
  children: null,
};
